<template>
  <vs-popup class="customer-sample-order-create-popup"
            title="SAMPLE ORDER CREATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card id="popup" no-shadow  v-if="is_load">

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSampleOrder)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-2/3 w-full md:mb-0">
                  <vs-table :data="cartItems" stripe>
                    <template slot="header">
                      <h3>

                      </h3>
                    </template>
                    <template slot="thead">
                      <vs-th width="20%">ITS PRODUCT CODE</vs-th>
                      <vs-th width="20%">ITS PRODUCT NAME</vs-th>
                      <vs-th width="10%">PRICE (GBP/KG)</vs-th>
                      <vs-th width="10%">QUANTITY (GRAMS)</vs-th>
                      <vs-th width="10%">NET VALUE (GBP)</vs-th>
                      <vs-th width="10%">PRODUCT SPEC AVAILABLE TO SEND</vs-th>
                      <vs-th width="10%"></vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].formulation_code">
                          {{ data[indextr].formulation_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].formulation_name">
                          {{ data[indextr].formulation_name }}
                        </vs-td>

                        <vs-td :data="data[indextr].price">
                          {{ Number(data[indextr].price).toFixed(2) }}
                        </vs-td>

                        <vs-td :data="data[indextr].quantity">
                          {{ data[indextr].quantity }}
                        </vs-td>

                        <vs-td :data="data[indextr].quantity">
                          {{ Number((data[indextr].quantity / 1000) * data[indextr].price).toFixed(2) }}
                        </vs-td>

                        <vs-td>
                          {{ product_spec_availability[data[indextr].formulation_code] ? 'Yes' : 'No' }}
                        </vs-td>

                        <vs-td :data="data[indextr].formulation_id">
                          <vx-tooltip class="" :text="`Remove ${data[indextr].formulation_code}` " position="left">
                            <vs-button @click="onClickRemoveFromCart(data[indextr].id)"
                                       size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                          </vx-tooltip>
                        </vs-td>

                      </vs-tr>
                    </template>

                  </vs-table>
            </div>

              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <vx-card>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="recipients" name="recipients" rules="" v-slot="{ errors }">
                      <small class="label">Send specification to the following users at dispatch stage</small>
                      <v-select :clearable="false" name="email" placeholder="" multiple
                                label="email" v-model="form.recipients" :reduce="option => option"
                                :options="email_list" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- <div class="vx-row mb-3" v-if="!!customer_lead_id">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="currency" name="currency" rules="required" v-slot="{ errors }">
                      <small class="label">Order currency</small>
                      <v-select :clearable="false" name="currency" placeholder=""
                                label="name" v-model="form.currency" :reduce="option => option.value"
                                :options="currencies" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div> -->
                <div class="vx-row mb-3">
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider vid="vat_number" name="vat_number" rules="" v-slot="{ errors }">
                        <small class="label">VAT Number</small>
                        <vs-input v-model="form.vat_number"  name="vat_number" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider vid="eori" name="eori" rules="" v-slot="{ errors }">
                        <small class="label">EORI</small>
                        <vs-input v-model="form.eori"  name="eori" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="customer_sample_order_no" name="customer_sample_order_no" rules="" v-slot="{ errors }">
                      <small class="label">Customer PO Number</small>
                      <vs-input class="mb-0" v-model="customer_sample_order_no" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div v-if="onClickAddressChange" class="vx-row mb-3">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="formulation_items" name="formulation_items" rules="required" v-slot="{ errors }">
                      <small class="label">Select a delivery address</small>
                      <v-select
                        v-on:input="onChangeSelectDeliveryAddress"
                        @search="onSearch"
                        name="formulation_items" placeholder=""
                        v-model="selectedAddress" :reduce="option => option"
                        label="country"
                        :options="addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            <span style="font-weight: normal">{{ option.type }}</span> <span v-if="option.type"> - </span>
                            <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                            <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            <span style="font-weight: normal">{{ option.type }}</span> <span v-if="option.type"> - </span>
                            <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                            <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                          </div>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3" v-if="onClickAddressChange">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <span style="cursor: pointer" class="float-right text-primary" @click="onClickAddressChange = false">or add delivery address</span>
                    </div>
                  </div>

               <span v-if="!onClickAddressChange">
                 <div class="vx-row mb-3">
                    <div class="vx-col w-full md:mb-0">
                      <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                        <small class="label">Address Name</small>
                        <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                 </div>
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                        <small class="label">Address Line 1</small>
                        <vs-input v-model="form.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                        <small class="label">Address Line 2</small>
                        <vs-input v-model="form.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 3</small>
                      <vs-input v-model="form.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                      <small class="label">Town / State</small>
                      <vs-input v-model="form.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                      <small class="label">Postal Code</small>
                      <vs-input v-model="form.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                                label="name" v-model="form.country" :reduce="option => option.name"
                                :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                  <div class="vx-row mb-3">
                      <div class="vx-col md:w-full w-full md:mb-0">
                        <span style="cursor: pointer" class="float-right text-primary" @click="onClickAddressChange = true">change delivery address</span>
                      </div>
                  </div>


               </span>

               <div class="vx-row mb-3" v-if="!is_address_clicked_from_pick_list">
                <div class="vx-col w-full">
                  <small class="label mb-2">Add address to customer sites?</small>
                  <vs-switch v-model="form.is_site_address_to_be_added"></vs-switch>
                </div>
               </div>

                <div class="vx-row mb-3">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                      <small class="label">Delivery Instructions</small>
                      <vs-textarea class="mb-0" v-model="form.delivery_instruction" height="100px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                      <small class="label">Notes</small>
                      <vs-textarea class="mb-0" v-model="form.notes" height="100px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                </vx-card>
              </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Order</vs-button>
            <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  const CrmRepository = RepositoryFactory.get('crm');
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations';
  import { mapActions, mapGetters } from 'vuex';

  function initialState() {
    return {
      open: false,
      customer_id: null,
      customer_lead_id: null,
      is_free_of_charge: false,
      form: {
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction: '',
        formulation_items: [],
        is_site_address_to_be_added: false,
        recipients: [],
        eori: '',
        vat_number: '',
        currency: 'GBP'
      },
      countryCodes: [],
      customerUsers: [],
      isCreateFromMainMenu: false,
      customers: [],
      formulations: [],
      addresses: [],
      selectedAddress: '',
      cartItems: [],
      onClickAddressChange: true,
      is_address_clicked_from_pick_list: false,
      is_load: false,
      email_list: [],
      product_spec_availability: {},
      customer_sample_order_no: "",
    }
  }

export default {
  name: 'GeneratePdfSampleOrderPopUp',
  data () {
    return initialState()
  },
  methods:{
    ...mapActions(['fetchCurrencyList']),
    async openPopup (customer_id, customer_lead_id, is_free_of_charge = false, customer_sample_order_no = "") {
      try {
        await Object.assign(this.$data, initialState())
        this.customer_id = customer_id
        this.customer_lead_id = customer_lead_id
        this.is_free_of_charge = is_free_of_charge
        this.customer_sample_order_no = customer_sample_order_no
        await this.getCountryCodes()
        await this.getAddresses()
        await this.fetchEmailList()
        await this.getItemsInItemsCart()
        await this.fetchSpecAvailability()
        await this.fetchCustomerData()
        if(this.customer_lead_id) {
          // await this.fetchCurrencyList()
        }
        // this.getFormulations()
        this.open = true;
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async onClickClose() {
      const vue = this;
      this.open = false
      await vue.$parent.onlyRefreshData()
    },
    async onClickCreateSampleOrder () {
      const vue = this;
      this.$vs.loading()
       try {
         this.form.customer_id = this.customer_id
         this.form.customer_lead_id = this.customer_lead_id
         this.form.is_chargeable = !this.is_free_of_charge 
         this.form.customers_order_number = this.customer_sample_order_no || null

         this.form.formulation_items = this.cartItems.map((m) => {
           return { id: m.formulation_id, quantity: m.quantity, price: m.price }
         })
         if (this.customer_id) { 
            delete this.form.customer_lead_id
            // delete this.form.currency
         }
         else if (this.customer_lead_id) delete this.form.customer_id;
         this.form.recipients = this.form.recipients.map((x) => {
          return { id: x.id, type: x.type }
         })
         await CustomerRepository.createCustomerSampleOrder(this.form)
         this.showSuccessMessage('Sample order created successfully')
         this.open = false;
         await vue.$parent.refreshData()

       }catch (e) {
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async getFormulations() {
      this.$vs.loading()
      const {data} = await FormulationsRepository.get(1, '', 50, '')
      this.formulations =  data.data
      this.$vs.loading.close()
    },
    async getCountryCodes() {
      this.$vs.loading()
      this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
      this.$vs.loading.close()
    },
    async getAddresses() {
      this.$vs.loading()
      try {
        if(this.customer_lead_id) {
          this.addresses = (await CrmRepository.getLeadAddressList(this.customer_lead_id)).data.data
        }
        if(this.customer_id) {
          this.addresses = (await CustomerRepository.getSampleDeliveryAddresses(this.customer_id)).data.data;
        }
        if(this.addresses.length === 0) {
          this.onClickAddressChange = false
        }
        if(this.addresses.length === 1) {
          this.onChangeSelectDeliveryAddress(this.addresses[0])
        }
      } catch (error) {
        this.convertAndNotifyError(error);
      }
      this.$vs.loading.close()
    },
    async fetchEmailList() {
      if(this.customer_id) {
        const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.customer_id)).data
        this.email_list = data.map((x) => {
          x.type = 'customer'
          return x
        })
      }
      if(this.customer_lead_id) {
        const { data } = (await CrmRepository.getMerketingLeadDetails(this.customer_lead_id)).data
        this.email_list = [ { email: data.email, type: 'lead', id: data.id } ]
      }
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    doCheckItems(data) {

    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    async getItemsInItemsCart() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        const queries = this.customer_id ? `customer_id=${this.customer_id}` : (this.customer_lead_id ? `customer_lead_id=${this.customer_lead_id}` : '');
        const {data} = (await CustomerRepository.getItemsInItemsCart(queries)).data
        this.cartItems = data
        this.is_load = !this.is_load
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async fetchSpecAvailability() {
      try {
        const { data } = ( await FormulationsRepository.checkSpectOfProduct( { formulations: this.cartItems.map((x) => x.formulation_code ) } ) ).data
        this.product_spec_availability = data
      } catch (error) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickRemoveFromCart(id) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        await CustomerRepository.removeFormulationsFromCart(id)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Removed from cart')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async fetchCustomerData() {
      try {
        if(this.customer_id) {
          const { data } = (await CustomerRepository.getCustomerDetails(this.customer_id)).data
          this.form.eori = data.eori
          this.form.vat_number = data.is_vat_registration_text
        }
      } catch (error) {
        
      }
    },
    onChangeSelectDeliveryAddress(selected) {
      this.form.name = selected.name
      this.form.line1 = selected.line1
      this.form.line2 = selected.line2
      this.form.line3 = selected.line3
      this.form.town_state = selected.town_state
      this.form.post_code = selected.post_code
      this.form.country = selected.country

      this.form.delivery_instruction = selected.additional_info
      this.onClickAddressChange = false
      this.is_address_clicked_from_pick_list = true
    },
    search: _.debounce( async (loading, search, vm) => {
      const {data} = await FormulationsRepository.get(1, `filter[search]=${search}`, 50, '')
      vm.formulations = data.data
      loading(false);
    }, 350)
  },
  async mounted () {

  },
  computed: {
    ...mapGetters(['currencies']),
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations],
}
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    /*min-height: 80% !important;*/
    min-width: 80% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
